module.exports = __webpack_public_path__ + "img/Flags_mex.a7ac0b77.svg";